import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Tag,
  Menu,
  Dropdown,
  Icon,
  Input,
  Button,
  Modal,
  Select,
  DatePicker,
  message,
  Table,
  Avatar,
  Card,
} from "antd";
import "../share-points-analytics/SharePoint.scss";
import moment from "moment";

import { ReactComponent as ReferEarnLogo } from "./images/ReferEarnLogo.svg";

import { ReactComponent as GraphLink } from "./images/GraphLink.svg";
import { ReactComponent as GraphPending } from "./images/GraphPending.svg";
import { ReactComponent as GraphTick } from "./images/GraphTick.svg";
import { ReactComponent as GraphCoin } from "./images/GraphCoin.svg";
import { ReactComponent as GraphAverage } from "./images/GraphAverage.svg";
import { ReactComponent as GraphBills } from "./images/GraphBills.svg";
import DubaiImage from "./images/Dubai.png";
import Level1Logo from "./images/Level1Logo.png";
import Level2Logo from "./images/Level2Logo.png";
import ReferEarnLimitLogo from "./images/ReferEarnLimitLogo.png";
import { ReactComponent as DubaiLogo } from "../share-points-analytics/images/DubaiLogo.svg";
import Loader from "../../components/Loader/Loader";
import RecentTransactions from "../share-points-analytics/RecentTransactions";
import {
  fetchSharePointsAdminDataApi,
  fetchSharePointsAdminRecentTxnsApi,
} from "utils/apiService";
import LeaderBoard from "../share-points-analytics/LeaderBoard";
import BarPlots from "../share-points-analytics/BarPlots";
import DataEditor, { DataEditorContainer } from "@glideapps/glide-data-grid";

const { Text } = Typography;

const ReferEarnAnalytics = () => {
  const Today = new moment();
  Today.format("YYYY-MM-DD");
  const columns = [
    { title: "First", width: 150 },
    { title: "Second", width: 150 },
  ];

  const [loading, setLoading] = useState(true);
  const [sharePointAnalytics, setSharePointAnalytics] = useState({});
  const [settingModal, setSettingModal] = useState(false);
  const [range, setRange] = useState({
    start_date: Today,
    end_date: Today,
  });
  const formatDate = (date, from, to) => {
    var newDate = date ? new moment(date, from) : new moment();

    return newDate.format(to);
  };
  const loadData = () => {
    fetchSharePointsAdminDataApi({
      requestData: {
        start_date: formatDate(range.start_date, "YYYY-MM-DD", "DD-MM-YYYY"),
        end_date: formatDate(range.end_date, "YYYY-MM-DD", "DD-MM-YYYY"),
      },
      res200Callback: async (res) => {
        await setSharePointAnalytics(res.data);
        setLoading(false);

        // message.success("Hello");
      },
      resCallback: (res) => {
        // debugger;
      },
      resErrorCallback: (err) => {
        // debugger;
        message.error(JSON.stringify(err.data));
      },
    });
  };

  useEffect(() => {
    loadData();
  }, [range]);
  return (
    <>
      {loading && (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#FAFAFA",
          }}
        >
          <Loader />
        </div>
      )}
      {!loading && (
        <Row
          style={{
            width: "100%",
            padding: "40px 25px 0",
            margin: "60px auto 20px",
            backgroundColor: "#FAFAFA",
          }}
          gutter={[12, 48]}
        >
          <Row
            style={{
              display: "flex",

              // justifyContent: "space-between",
            }}
          >
            <Text
              style={{
                width: "75%",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "24px",

                lineHeight: "40px",
                color: "#181818",
              }}
            >
              Refer and Earn Dashboard
            </Text>
            <Row
              style={{
                display: "flex",
                // width: "40%",
                justifyContent: "space-between",
              }}
            >
              <DatePicker.RangePicker
                style={{ width: "281px", background: "#FFFFFF" }}
                format={"DD MMM YYYY"}
                onChange={(e) => {
                  setRange({
                    start_date: e[0] ? e[0].format("YYYY-MM-DD") : "2021-11-09",
                    end_date: e[1] ? e[1].format("YYYY-MM-DD") : "",
                  });
                }}
              />
              <Button
                type="primary"
                style={{
                  width: "115px",
                  height: "40px",
                  background: "#FFFFFF",
                  border: "1px solid #D1D1D1",
                  boxSizing: "border-box",
                  borderRadius: "4px",
                  marginLeft: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "#181818",
                  padding: "8px 16px",
                }}
                onClick={() => {
                  setSettingModal(true);
                }}
              >
                <Icon type="setting" theme="outlined" />

                <Text
                  style={{
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#181818",
                  }}
                >
                  Settings
                </Text>
              </Button>
            </Row>
          </Row>
          <Row
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <div
              style={{
                width: "70%",
              }}
            >
              <Row
                style={{
                  marginTop: "32px",
                }}
              >
                <Row
                  style={{
                    width: "100%",
                    height: "180px ",
                    background: "#37454F",
                    borderRadius: "8px",
                    // display: "flex",
                    // justifyContent: "space-between",
                  }}
                >
                  <Col span={12}>
                    <Row style={{ margin: "24px" }}>
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <ReferEarnLogo
                          style={{ width: "50px", height: "50px" }}
                        />
                        <div
                          style={{
                            display: "flex",
                            marginLeft: "12px",
                            flexDirection: "column",
                          }}
                        >
                          <Text
                            style={{
                              fontStyle: "normal",
                              fontWeight: "700",
                              fontSize: "20px",
                              lineHeight: "32px",
                              color: "#FFFFFF",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Referral Status
                          </Text>
                          <Text
                            style={{
                              fontStyle: "normal",
                              fontWeight: "500",
                              fontSize: "12px",
                              lineHeight: "18px",
                              color: "#FFFFFF",
                            }}
                          >
                            {range.start_date == range.end_date
                              ? `${formatDate(
                                  range.start_date,
                                  "YYYY-MM-DD",
                                  "Do MMM  YYYY"
                                )}`
                              : `${formatDate(
                                  range.start_date,
                                  "YYYY-MM-DD",
                                  "Do MMM  YYYY"
                                )} - ${formatDate(
                                  range.end_date,
                                  "YYYY-MM-DD",
                                  "Do MMM  YYYY"
                                )}`}
                            {/* {"23rd Sept 2021 - 14th Oct 2021"} */}
                          </Text>
                        </div>
                      </div>
                    </Row>
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "12px",
                        flexDirection: "column",
                        width: "550px",
                        margin: "24px",
                      }}
                    >
                      <div
                        style={{
                          fontStyle: "normal",
                          fontWeight: "1000",
                          fontSize: "20px",
                          lineHeight: "32px",
                          color: "#FFFFFF",
                          display: "flex",
                          width: "50%",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>{sharePointAnalytics.total_points}</span>
                        <span style={{ width: "26%" }}>
                          {sharePointAnalytics.total_aed}
                        </span>
                      </div>
                      <div
                        style={{
                          fontStyle: "normal",
                          fontWeight: "500",
                          fontSize: "12px",
                          lineHeight: "18px",
                          color: "#FFFFFF",

                          width: "50%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>Total Referals</span>

                        <span style={{ width: "26%", whiteSpace: "nowrap" }}>
                          Total Amount Spent
                        </span>
                      </div>
                    </div>
                    <Row></Row>
                  </Col>
                  <Col span={10}></Col>
                </Row>
              </Row>
              <img
                style={{
                  height: "210px",
                  width: "331px",
                  position: "absolute",
                  left: "35%",
                  top: "3px",
                }}
                src={DubaiImage}
              />
              <Row
                style={{
                  background: "#FFFFFF",
                  marginTop: "44px",
                  borderRadius: "5px",
                  padding: "24px",
                }}
              >
                <Row>
                  <Avatar
                    size={32}
                    src={Level1Logo}
                    style={{ marginRight: "8px" }}
                  />
                  <Text
                    style={{
                      color: "#181818",
                      fontStyle: "normal",
                      fontWeight: "bold",
                      fontSize: "20px",
                      lineHeight: "32px",

                      position: "absolute",
                      top: "3px",
                    }}
                  >
                    Level 1 Referral
                  </Text>
                  <Text
                    style={{
                      lineHeight: "18px",
                      fontSize: "16px",
                      fontWeight: "300",
                      marginLeft: "8px",
                      position: "absolute",
                      left: "195px",
                      top: "11px",
                    }}
                  >
                    Downloads
                  </Text>
                </Row>
                <Row
                  gutter={16}
                  style={{ marginTop: "32px", marginLeft: "2px" }}
                >
                  <Col
                    span={5}
                    style={{
                      background: "#F3F9F4",
                      borderRadius: "5px",
                      border: "1px solid #fec708",
                      marginRight: "20px",
                      height: "120px",
                    }}
                  >
                    <div>
                      <div>
                        <GraphTick
                          style={{
                            width: "24px",
                            height: "24px",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          lineHeight: "32px",
                          fontWeight: "bold",
                          color: "#fec708",
                        }}
                      >
                        {"500"}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                        }}
                      >
                        <Text>Customers completed Level 1 Refferal</Text>
                      </div>
                    </div>
                  </Col>
                  <Col
                    span={5}
                    style={{
                      //   background: "#F3F9F4",
                      borderRadius: "5px",
                      border: "1px solid #D1D1D1",
                      marginRight: "20px",
                      height: "120px",
                    }}
                  >
                    <div>
                      <div>
                        <GraphCoin
                          style={{
                            width: "24px",
                            height: "24px",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          lineHeight: "32px",
                          fontWeight: "bold",
                        }}
                      >
                        {"500"}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                        }}
                      >
                        <Text>Amount spent in Level 1 Referrals</Text>
                      </div>
                    </div>
                  </Col>{" "}
                  <Col
                    span={5}
                    style={{
                      //   background: "#F3F9F4",
                      borderRadius: "5px",
                      border: "1px solid #D1D1D1",
                      marginRight: "20px",
                      height: "120px",
                    }}
                  >
                    <div>
                      <div>
                        <GraphLink
                          style={{
                            width: "24px",
                            height: "24px",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          lineHeight: "32px",
                          fontWeight: "bold",
                        }}
                      >
                        {"500"}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                        }}
                      >
                        <Text>Number of links shared in Level 1 Referrals</Text>
                      </div>
                    </div>
                  </Col>{" "}
                  <Col
                    span={5}
                    style={{
                      //   background: "#F3F9F4",
                      borderRadius: "5px",
                      border: "1px solid #D1D1D1",
                      marginRight: "20px",
                      height: "120px",
                    }}
                  >
                    <div>
                      <div>
                        <GraphPending
                          style={{
                            width: "24px",
                            height: "24px",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          lineHeight: "32px",
                          fontWeight: "bold",
                        }}
                      >
                        {"500"}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                        }}
                      >
                        <Text>Number of pending Referals</Text>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <BarPlots
                    title={"Recent Shared Stats"}
                    data={sharePointAnalytics.amount_shared_list.map((item) => {
                      return {
                        date: formatDate(
                          item.date,
                          "DD-MM-YYYY",
                          "MMM Do YYYY"
                        ),
                        "Amount shared": item.amount_shared,
                      };
                    })}
                    stacked={false}
                    stackFeild={""}
                    xaxis={"date"}
                    yaxis={"Amount shared"}
                    color={"#fec708"}
                  />
                </Row>
              </Row>

              <Row
                style={{
                  background: "#FFFFFF",
                  marginTop: "44px",
                  borderRadius: "5px",
                  padding: "24px",
                }}
              >
                <Row>
                  <Avatar
                    size={32}
                    src={Level2Logo}
                    style={{ marginRight: "8px" }}
                  />
                  <Text
                    style={{
                      color: "#181818",
                      fontStyle: "normal",
                      fontWeight: "bold",
                      fontSize: "20px",
                      lineHeight: "32px",
                      position: "absolute",
                      top: "3px",
                    }}
                  >
                    Level 2 Referral
                  </Text>
                  <Text
                    style={{
                      lineHeight: "18px",
                      fontSize: "16px",
                      fontWeight: "300",
                      marginLeft: "8px",
                      position: "absolute",
                      left: "195px",
                      top: "11px",
                    }}
                  >
                    First Purchase
                  </Text>
                </Row>
                <Row
                  gutter={16}
                  style={{ marginTop: "32px", marginLeft: "2px" }}
                >
                  <Col
                    span={5}
                    style={{
                      background: "#F3F9F4",
                      borderRadius: "5px",
                      border: "1px solid #fec708",
                      marginRight: "20px",
                      height: "120px",
                    }}
                  >
                    <div>
                      <div>
                        <GraphTick
                          style={{
                            width: "24px",
                            height: "24px",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          lineHeight: "32px",
                          fontWeight: "bold",
                          color: "#fec708",
                        }}
                      >
                        {"500"}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                        }}
                      >
                        <Text>Customers completed Level 2 Refferal</Text>
                      </div>
                    </div>
                  </Col>
                  <Col
                    span={5}
                    style={{
                      //   background: "#F3F9F4",
                      borderRadius: "5px",
                      border: "1px solid #D1D1D1",
                      marginRight: "20px",
                      height: "120px",
                    }}
                  >
                    <div>
                      <div>
                        <GraphCoin
                          style={{
                            width: "24px",
                            height: "24px",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          lineHeight: "32px",
                          fontWeight: "bold",
                        }}
                      >
                        {"500"}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                        }}
                      >
                        <Text>Amount spent in Level 2 Referrals</Text>
                      </div>
                    </div>
                  </Col>{" "}
                  <Col
                    span={5}
                    style={{
                      //   background: "#F3F9F4",
                      borderRadius: "5px",
                      border: "1px solid #D1D1D1",
                      marginRight: "20px",
                      height: "120px",
                    }}
                  >
                    <div>
                      <div>
                        <GraphPending
                          style={{
                            width: "24px",
                            height: "24px",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          lineHeight: "32px",
                          fontWeight: "bold",
                        }}
                      >
                        {"500"}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                        }}
                      >
                        <Text>Total Number of Pending Referals</Text>
                      </div>
                    </div>
                  </Col>{" "}
                  <Col
                    span={5}
                    style={{
                      //   background: "#F3F9F4",
                      borderRadius: "5px",
                      border: "1px solid #D1D1D1",
                      marginRight: "20px",
                      height: "120px",
                    }}
                  >
                    <div>
                      <div>
                        <GraphAverage
                          style={{
                            width: "24px",
                            height: "24px",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          lineHeight: "32px",
                          fontWeight: "bold",
                        }}
                      >
                        {"500"}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                        }}
                      >
                        <Text>Average Value to bill</Text>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row
                  gutter={16}
                  style={{ marginTop: "20px", marginLeft: "2px" }}
                >
                  <Col
                    span={5}
                    style={{
                      background: "#F3F9F4",
                      borderRadius: "5px",
                      border: "1px solid #fec708",
                      marginRight: "20px",
                      height: "120px",
                    }}
                  >
                    <div>
                      <div>
                        <GraphBills
                          style={{
                            width: "24px",
                            height: "24px",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          lineHeight: "32px",
                          fontWeight: "bold",
                          color: "#fec708",
                        }}
                      >
                        {"500"}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          lineHeight: "18px",
                        }}
                      >
                        <Text>Number of Bills </Text>
                      </div>
                    </div>
                  </Col>
                </Row>
                <BarPlots
                  title={"Transaction Status Stats"}
                  data={sharePointAnalytics.txn_count_list.map((item) => {
                    return {
                      ...item,
                      ["date"]: formatDate(
                        item.date,
                        "DD-MM-YYYY",
                        "MMM Do YYYY"
                      ),
                    };
                  })}
                  //   stacked={true}
                  //   stackFeild={"status"}
                  xaxis={"date"}
                  yaxis={"count"}
                  color={"#fec708"}
                />
              </Row>
            </div>
            <div
              style={{
                width: "30%",
                marginLeft: "32px",
              }}
            >
              <Row></Row>
              <Row>
                <div
                  style={{
                    width: "100%",
                    height: "180px ",
                    background: "#99EEFF",
                    borderRadius: "8px",
                    marginTop: "32px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Row>
                    <div
                      style={{
                        marginTop: "16px",
                        marginLeft: "24px",
                        // display: "flex",
                        // flexDirection: "column",
                      }}
                    >
                      <Text
                        style={{
                          fontStyle: "normal",
                          fontWeight: "600",
                          fontSize: "14px",
                          lineHeight: "22px",
                          color: "#464646",
                        }}
                      >
                        Lifetime
                      </Text>
                      <div
                        style={{
                          marginTop: "4px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text
                          style={{
                            width: "40%",
                            fontStyle: "normal",
                            fontWeight: "bold",
                            fontSize: "24px",
                            lineHeight: "40px",
                            color: "#181818",
                          }}
                        >
                          {sharePointAnalytics.total_lifetime_points}
                        </Text>
                        <Text
                          style={{
                            width: "50%",
                            fontStyle: "normal",
                            fontWeight: "bold",
                            fontSize: "24px",
                            lineHeight: "40px",
                            color: "#181818",
                          }}
                        >
                          {sharePointAnalytics.total_lifetime_aed}
                        </Text>
                      </div>
                      <div
                        style={{
                          // marginTop: "2px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text
                          style={{
                            width: "40%",
                            fontStyle: "normal",
                            fontWeight: "600px",
                            fontSize: "12px",
                            lineHeight: "18px",
                            color: "#464646",
                          }}
                        >
                          Total Referals
                        </Text>
                        <Text
                          style={{
                            width: "49%",
                            fontStyle: "normal",
                            fontWeight: "600px",
                            fontSize: "12px",
                            lineHeight: "18px",
                            color: "#464646",
                          }}
                        >
                          Total amount Spent
                        </Text>
                      </div>
                    </div>
                  </Row>
                  <DubaiLogo
                    style={{
                      width: "100%",
                      position: "absolute",
                      bottom: "0%",
                    }}
                  />
                </div>
              </Row>

              <Row
                style={{
                  marginTop: "44px",
                  borderRadius: "5px",
                  background: "#FFFFFF",
                  padding: "12px",
                }}
              >
                <LeaderBoard
                  leaderboard={sharePointAnalytics.leaderboard_list}
                />
              </Row>
            </div>
          </Row>
          <Modal
            centered
            visible={settingModal}
            destroyOnClose
            maskClosable={false}
            onCancel={() => setSettingModal(false)}
            footer={null}
            width={600}
          >
            <Row className="modal-row">
              <Row display={"flex"}>
                <Avatar
                  src={ReferEarnLimitLogo}
                  style={{
                    width: "35px",
                    height: "35px",
                    marginRight: "16px",
                  }}
                />
                <Text
                  style={{
                    fontWeight: "bold",
                    color: "#181818",
                    fontSize: "24px",
                    position: "absolute",
                  }}
                >
                  Set Refer and Earn Amount
                </Text>
              </Row>
              <Row style={{ marginTop: "40px" }}>
                <Avatar
                  size={20}
                  src={Level1Logo}
                  style={{ marginRight: "4px" }}
                />
                <Text
                  style={{
                    fontSize: "14px",
                    color: "#181818",
                    fontWeight: "bold",

                    lineHeight: "22px",
                    // fontWeight:"bold"
                  }}
                >
                  Level 1 Referral
                </Text>
                <Text
                  style={{
                    lineHeight: "18px",
                    fontSize: "12px",
                    fontWeight: "300",
                    marginLeft: "4px",
                    position: "absolute",
                    top: "3px",
                  }}
                >
                  Downloads
                </Text>
                <Input
                  className="time-value-cohort-col-main-element"
                  style={{ width: "100%", marginTop: "8px" }}
                  placeholder="Enter the Level 1 referral amount"
                  onChange={(event) => {}}
                />
              </Row>
              <Row style={{ marginTop: "40px" }}>
                <Avatar
                  size={20}
                  src={Level2Logo}
                  style={{ marginRight: "4px" }}
                />
                <Text
                  style={{
                    fontSize: "14px",
                    color: "#181818",
                    fontWeight: "bold",

                    lineHeight: "22px",
                    // fontWeight:"bold"
                  }}
                >
                  Level 2 Referral
                </Text>
                <Text
                  style={{
                    lineHeight: "18px",
                    fontSize: "12px",
                    fontWeight: "300",
                    marginLeft: "4px",

                    position: "absolute",
                    top: "3px",
                  }}
                >
                  First Purchase
                </Text>
                <Input
                  className="time-value-cohort-col-main-element"
                  style={{ width: "100%", marginTop: "8px" }}
                  placeholder="Enter the Level 2 referral amount"
                  onChange={(event) => {}}
                />
              </Row>
              <Row style={{ marginTop: "40px" }}>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <Button
                    size="large"
                    style={{
                      height: "40px",
                      boxShadow: "none",
                      border: "1px solid #D9D9D9",
                      borderRadius: "4px",
                      backgroundColor: "#FFFFFF",
                      color: "#181818",
                    }}
                    onClick={() => setSettingModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    size="large"
                    style={{
                      height: "40px",
                      width: "67px",
                      borderRadius: "4px",
                      border: "none",
                      background: "#fec708",
                      color: "#FFFFFF",
                      marginLeft: "16px",
                    }}
                    onClick={() => {
                      setSettingModal(false);
                    }}
                  >
                    Save
                  </Button>
                </Row>
              </Row>
            </Row>
          </Modal>
        </Row>
      )}
    </>
  );
};

export default ReferEarnAnalytics;
